import { useCallback } from 'react'
import type { NameofOptions } from 'ts-simple-nameof'
import { nameof } from 'ts-simple-nameof'

export function GetFormItemName<T extends object>(
  selector: (obj: T) => any,
  namePrefix?: string,
  options?: NameofOptions,
) {
  const propName = nameof(selector, options)

  return namePrefix && namePrefix.length > 0
    ? `${namePrefix}.${propName}`
    : propName
}

export const useNameof = <T extends object>(
  namePrefix?: string,
  options?: NameofOptions,
) =>
  useCallback(
    (selector: (obj: T) => any): string =>
      GetFormItemName(selector, namePrefix, options),
    [namePrefix],
  )
